<template>
  <el-dialog title="抽奖明细" :visible.sync="visible" width="800px" class="lottery-details-dialog" @close="handleClose" append-to-body :close-on-click-modal="false">
    <!-- 搜索栏 -->
    <div class="search-container">
      <el-input v-model="searchKeyword" placeholder="搜索" size="small" class="search-input" clearable @keyup.enter.native="handleSearch" />
      <el-button type="primary" size="small" class="search-btn" @click="handleSearch">搜索</el-button>
    </div>

    <!-- 列表 -->
    <div class="lottery-list">
      <div v-for="(item, idx) in filteredLotteryList" :key="idx" class="lottery-item">
        <div class="user-info">
          <el-avatar :src="item.avatar" size="medium" class="user-avatar" icon="el-icon-user" />
          <div class="user-details">
            <div>
              <span class="user-name">{{ item.userName }}</span>
              <span>（{{ item.userClass }}）</span>
              <span>{{ item.userId }}</span>
              <span class="lottery-result" :class="item.isWon ? 'won' : 'not-won'">
                · {{ item.isWon ? '中奖' : '未中奖' }}
              </span>
            </div>
            <div v-if="item.isWon" class="win-details">
              <div>中奖时间：{{ item.winTime }}</div>
              <div>中奖信息：{{ item.prizeInfo }}</div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="filteredLotteryList.length === 0" style="text-align:center;color:#999;padding:20px 0;">
        暂无数据
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      searchKeyword: '',
      // 示例数据，实际使用时请替换为父组件传入的数据
      lotteryList: [
        {
          avatar: '', // 头像图片地址
          userName: '杜三',
          userClass: '体验班',
          userId: '1456322124',
          isWon: true,
          winTime: '2025-02-11',
          prizeInfo: '商品名称-商品规格'
        },
        {
          avatar: '',
          userName: '杜三',
          userClass: '体验班',
          userId: '1456322124',
          isWon: false,
          winTime: '',
          prizeInfo: ''
        }
      ]
    }
  },
  computed: {
    filteredLotteryList() {
      if (!this.searchKeyword) return this.lotteryList
      return this.lotteryList.filter(item =>
        item.userName.includes(this.searchKeyword) ||
        item.userId.includes(this.searchKeyword)
      )
    }
  },
  methods: {
    handleShow(row) {
      this.visible = true
    },
    handleSearch() {
      // 这里只是本地过滤，实际可根据需要请求后端
    },
    handleClose() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style scoped>
.lottery-details-dialog .search-container {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.search-input {
  flex: 1;
}
.search-btn {
  margin-left: 8px;
}
.lottery-list {
  max-height: 400px;
  overflow-y: auto;
}
.lottery-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
}
.user-info {
  display: flex;
  align-items: flex-start;
}
.user-avatar {
  margin-right: 12px;
}
.user-details {
  flex: 1;
}
.user-name {
  font-size: 16px;
  margin-bottom: 4px;
}
.lottery-result {
  margin-left: 8px;
}
.lottery-result.won {
  color: #f56c6c;
}
.lottery-result.not-won {
  color: #909399;
}
.win-details {
  background: #f5f7fa;
  border-radius: 6px;
  padding: 8px 12px;
  margin-top: 6px;
  color: #909399;
  font-size: 14px;
}
</style>